import { dropLineBase } from 'components/common/Dnd/style';

export const mixins = {
  longText: {
    flexShrink: 1,
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  highlightedSongPseudo: {
    content: '""',
    left: 0,
    top: 0,
    position: 'absolute',
    width: 'calc(100% - 2px)',
    height: 'calc(100% - 2px)',
    pointerEvents: 'none',
  },

  noClickableFilter: {
    pointerEvents: 'none',
  },

  noScroll: {
    scrollbarWidth: 'none',

    // @ts-ignore
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },

  getStaticIconSize: (size: number) => ({
    minHeight: `${size}px`,
    height: `${size}px`,
    width: `${size}px`,
    minWidth: `${size}px`,
    maxWidth: `${size}px`,
    maxHeight: `${size}px`,
  }),

  withDropLine: {
    '& .asDropLine': {
      ...dropLineBase,
      position: 'absolute',
      width: '100%',
      pointerEvents: 'none',

      '&:not(:last-child)': {
        top: 0,
        transform: 'translateY(-50%)',
      },

      '&:last-child': {
        bottom: 0,
        transform: 'translateY(50%)',
      },
    },
  },

  roundedTop: {
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
  },

  roundedBottom: {
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
  },
};
